import createIcon from '../../createIcon';

/**
 * @component @name DataExploration
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJDMiAxMy4zMyAyLjI2IDE0LjYxIDIuNzQgMTUuNzdMOCAxMC41TDExLjMgMTMuMjhMMTQuNTggMTBIMTNWOEgxOFYxM0gxNlYxMS40MkwxMS40MSAxNkw4LjEyIDEzLjIxTDMuNzIgMTcuNjFDNS41MiAyMC4yNiA4LjU2IDIyIDEyIDIySDIwQzIxLjEgMjIgMjIgMjEuMSAyMiAyMFYxMkMyMiA2LjQ4IDE3LjUyIDIgMTIgMlpNMTkuNSAyMC41QzE4Ljk1IDIwLjUgMTguNSAyMC4wNSAxOC41IDE5LjVDMTguNSAxOC45NSAxOC45NSAxOC41IDE5LjUgMTguNUMyMC4wNSAxOC41IDIwLjUgMTguOTUgMjAuNSAxOS41QzIwLjUgMjAuMDUgMjAuMDUgMjAuNSAxOS41IDIwLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DataExploration = createIcon('DataExploration', [
  [
    'path',
    {
      d: 'M12 2C6.48 2 2 6.48 2 12C2 13.33 2.26 14.61 2.74 15.77L8 10.5L11.3 13.28L14.58 10H13V8H18V13H16V11.42L11.41 16L8.12 13.21L3.72 17.61C5.52 20.26 8.56 22 12 22H20C21.1 22 22 21.1 22 20V12C22 6.48 17.52 2 12 2ZM19.5 20.5C18.95 20.5 18.5 20.05 18.5 19.5C18.5 18.95 18.95 18.5 19.5 18.5C20.05 18.5 20.5 18.95 20.5 19.5C20.5 20.05 20.05 20.5 19.5 20.5Z',
      key: '1uu2bu',
    },
  ],
]);

export default DataExploration;
